import * as React from 'react';

import HelpArticle32 from './HelpArticle32';

export const helpArticle32 = () => <HelpArticle32 />;

export default {
    title: 'Icon/Logo/HelpArticle32',
    component: HelpArticle32,
    parameters: {
        notes: "`import HelpArticle32 from 'box-ui-elements/es/icon/logo/HelpArticle32';`",
    },
};
